let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("wnH66")).then(() => parcelRequire('gj4bv'));